import React, { useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "../common/SideBar";
import StartExamButton from "../common/StartExamButton";
import LogoContainer from "./LogoContainer";
import SearchContainer from "./SearchContainer";
import ProfileContainer from "./ProfileContainer";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const [menuShow, setMenuShow] = useState(false);

  const handleMenu = (e) => {
    setMenuShow((prev) => !prev);
  };

  return (
    <>
      <nav className="flex flex-row justify-between items-center">
        {/* LOGO CONTAINER */}
        <Link to="/client/home">
          <LogoContainer />
        </Link>

        {/* Search Conainer */}
        <div className="sm:block hidden">
          <SearchContainer />
        </div>

        {/* Button Container */}
        <div className="md:block hidden">
          <StartExamButton
            data="Start Exam"
            styles="bg-secondary text-primary py-2"
          />
        </div>

        <div className="flex flex-row gap-3">
          {/* Profile Container */}
          <Link to="/client/profile">
            <ProfileContainer />
          </Link>

          {/* Mobile Menu */}
          <div className="sm:hidden flex">
            <button type="button" onClick={handleMenu}>
              {menuShow ? (
                <FaTimes className="text-[24px]" />
              ) : (
                <FaBars className="text-[24px]" />
              )}
            </button>
          </div>
        </div>
      </nav>
      {menuShow && (
        <div className="absolute right-3 top-16 p-3 bg-primary rounded-lg shadow-md">
          <SideBar />
        </div>
      )}
    </>
  );
};

export default Header;
